import type { HelpFile } from '../../types/help'
import { AutoAssignRuleRequestEditTestIds } from '../../../testids/AutoAssignRuleRequestEditTestIds'

export const autoAssignRuleRequestEditHelp: HelpFile = {
  docPage: '/docs/governance/auto-assign-rules',
  texts: {
    [AutoAssignRuleRequestEditTestIds.autoAssignRuleRequestEditPage]: 'Edit a draft auto-assign rule change request — adjust the expression, access profiles, and approvers before submitting.',
    [AutoAssignRuleRequestEditTestIds.btnBackNotEditable]: 'Return to the request detail. The request is no longer editable in its current state.',
  },
}
